import { HandType } from '@ps/web-poker-types';
import { formatCurrency } from '@ps/web-poker-utils';

import { formatRange } from '..';
import i18n from '../../i18n';
import type { Language } from '../../types';
import { isLimitGame } from '../helpers';
import { AttributeKey, TableFlags2 } from '../types';

// TODO: fix naming conventions
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface ITableAttributes {
  minChipsLimit: number;
  maxBuyIn: number;
  blinds: number[];
  currency: number | string;
  ante: number;
  flags2?: TableFlags2;
  game: number;
  stakes: number[];
  isPlayMoney: number;
  structure: number;
  scalePM: number;
  loBet: number;
  hiBet: number;
}

export default function tableAttrFormater(
  {
    minChipsLimit,
    maxBuyIn,
    blinds,
    currency,
    ante,
    flags2: tableFlags2,
    game,
    stakes,
    isPlayMoney,
    structure,
    scalePM,
    loBet,
    hiBet
  }: ITableAttributes,
  language?: Language
) {
  const i18nInstance = i18n(language);

  const options = {
    shorten: true,
    separators: true,
    isPlayMoney,
    scalePM
  };

  // When scalePM is more than 1 server data returns already scaled blinds.
  // Descale here and scale in formatCurrency
  const descaledBlinds =
    isPlayMoney && scalePM > 1 ? blinds.map((blind) => blind / scalePM) : blinds;

  const attributes = [
    {
      name: i18nInstance('TXTWBCLI_Buy_In'),
      value: formatRange({
        range: isLimitGame(structure) ? [minChipsLimit] : [minChipsLimit, maxBuyIn],
        currency,
        separator: isLimitGame(structure) ? '+' : '-',
        options
      }),
      key: AttributeKey.buyIn
    }
  ];

  // @ts-ignore TODO: fix type errors
  // eslint-disable-next-line no-bitwise
  if (tableFlags2 & TableFlags2.TABLESCRIPT_FLAG2_BUTTON_BLIND) {
    attributes.push(
      {
        name: i18nInstance('TXTWBCLI_Ante'),
        value: formatCurrency(ante, currency, options),
        key: AttributeKey.ante
      },
      {
        name: i18nInstance('TXTWBCLI_Button_Blind'),
        value: formatCurrency(descaledBlinds[0], currency, options),
        key: AttributeKey.buttonBlind
      }
    );
    return attributes;
  }

  if (ante && game !== HandType.ALL_IN_POKER) {
    attributes.push({
      name: i18nInstance('TXTWBCLI_Ante'),
      value: formatCurrency(ante, currency, options),
      key: AttributeKey.ante
    });
  }

  if (game === HandType.STUD || game === HandType.RAZZ) {
    attributes.push({
      name: i18nInstance('TXTWBCLI_Stakes'),
      value: formatRange({
        range: isLimitGame(structure) ? [loBet, hiBet] : stakes,
        currency,
        options
      }),
      key: AttributeKey.stakes
    });
    return attributes;
  }

  attributes.push({
    name: i18nInstance('TXTWBCLI_Stakes'),
    value: formatRange({
      range: isLimitGame(structure) ? [loBet, hiBet] : descaledBlinds,
      currency,
      options
    }),
    key: AttributeKey.stakes
  });
  return attributes;
}
